import React from 'react';
import { Avatar, useChatContext } from 'stream-chat-react';

const TeamChannelPreview = ({channel, type, setToggleContainer, setIsCreating, setIsEditing, setActiveChannel}) => { //destructing from previewProps from ChannelListContainer

    const { channel: activeChannel, client } = useChatContext(); //renaming as activeChannel as we've another channel coming from previewProps

    const ChannelPreview = () => (
        <p className="channel-preview__item">
            # {channel?.data?.name || channel?.data?.id}
        </p>
    );

    const DirectPreview = () => {
        //client.userID is our ID. we're basically filtering ourselves out from the list of persons we wanna chat
        /*Object.values because channel.state.members doesn't return an array of object,
        instead it returns an object of many key-value pairs. key -> ID and value -> user object => { '123' : {user}, '12345': {anotheruser}} 
        So to convert it into an array of key-value pairs, we're using Object.values(). 
        [] -- wrong expln I guess Object.values() converts that obj into array of objects that we can map through ]
        Object.values() will give us values of all the items in that specific member's object */
        const members = Object.values(channel.state.members).filter(({ user }) => user.id !== client.userID);

        return(
            <div className="channel-preview__item single">
                <Avatar 
                    image={members[0]?.user?.image}
                    name={members[0]?.user?.fullName || members[0]?.user?.id} //fullName won't be available for users created via getStream. It'll be available only for users created via our app
                    size={24}
                />
                <p>{members[0]?.user?.fullName || members[0]?.user?.id}</p>
            </div>
        )
    }
  return (
    <div className={
        channel?.id === activeChannel?.id
            ? 'channel-preview__wrapper__selected'
            : 'channel-preview__wrapper'
    }
    onClick={() => { //opening the channel once we click on it
        setIsCreating(false);
        setIsEditing(false); //If we've been editing something when clicking this, it'll be set to false
        setActiveChannel(channel);

        if(setToggleContainer){
            setToggleContainer((prevState) => !prevState);
        }
    }}
    >
        {type === 'team' ? <ChannelPreview /> : <DirectPreview />}
    </div>
    );
};

export default TeamChannelPreview;
